<template>
  <div class="mb-3">
    <label :for="id"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :id="id"
      :name="name"
      :rules="validationRules"
      v-slot="{ field, meta }"
    >
      <input
        v-bind="field"
        :id="id"
        type="password"
        :placeholder="placeholder"
        :class="[
          'form-control',
          { 'is-invalid': meta.touched && !meta.valid },
          { 'is-valid': meta.touched && meta.valid },
        ]"
      />
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});
</script>
